import { render, staticRenderFns } from "./ManageShortcutsModal.vue?vue&type=template&id=87cedd46"
import script from "./ManageShortcutsModal.vue?vue&type=script&lang=js"
export * from "./ManageShortcutsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports